"use client"

import { useSyncExternalStore } from "react"

const EMPTY_SUBSCRIBE = () => () => {}

export function useHydrated() {
  return useSyncExternalStore(
    EMPTY_SUBSCRIBE,
    () => true,
    () => false
  )
}
